import type { ProductCardSortBy } from "@/types/ingestedProduct";

/** Wire values for the sort select, in menu order. */
export const PRODUCT_CARD_SORT_BY_VALUES = [
  "score",
  "newest",
  "alphabetical",
  "low_stock",
] as const satisfies readonly ProductCardSortBy[];

export const PRODUCT_CARD_SORT_BY_LABEL: Record<ProductCardSortBy, string> = {
  score: "SKU Score",
  newest: "Newest",
  alphabetical: "Alphabetical",
  low_stock: "Low/Out of Stock",
};

/** Sort select option shown when no `sort_by` is set (catalog order). */
export const PRODUCT_CARD_DEFAULT_SORT_LABEL = "Default";
